export default {
  LOADING: 'ADMIN_VIEW_LOADING',
  LOADED: 'ADMIN_VIEW_LOADED',
};
